export default "__VITE_ASSET__CgllNBdk__"